import { AssetPrecisionEnum, ChainsDictionary, ChainsEnum } from '@/config';

const EXCLUSION_PRECISION = 0;
const EXCLUSION_VIEW_PRECISION = 9;

const ASSET_SUBSTITUTIONS = {
  [ChainsDictionary[ChainsEnum.BSC].symbol]: ChainsEnum.BSC,
  [ChainsEnum.MATIC]: ChainsEnum.POLYGON,
};

export default function getAssetPrecisions(asset: string, network: string) {
  let searchKey = asset;

  if ([ChainsEnum.ARB, ChainsEnum.TON].includes(network as ChainsEnum)) {
    return [EXCLUSION_PRECISION, EXCLUSION_VIEW_PRECISION];
  }
  if ([ChainsEnum.OP, ChainsEnum.BASE].includes(network as ChainsEnum)) {
    searchKey = network;
  }

  const dictionaryAsset =
    ChainsDictionary[searchKey] ||
    ChainsDictionary[ASSET_SUBSTITUTIONS[searchKey]];

  if (!!dictionaryAsset) {
    return [dictionaryAsset.precision, dictionaryAsset.viewPrecision];
  }

  return [
    AssetPrecisionEnum.PRECISION_DEFAULT,
    AssetPrecisionEnum.VIEW_PRECISION_DEFAULT,
  ];
}
